/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Tier_PlatinumInputs */



/**
* | output |
* | --- |
* | "Platinum" |
*
* @param {Partner_Admin_Tier_PlatinumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_tier_platinum = /** @type {((inputs?: Partner_Admin_Tier_PlatinumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Tier_PlatinumInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Platinum")
	return /** @type {LocalizedString} */ ("Platinum")
});